import { FundriseRouteConfig } from 'vue-router';

/* eslint-disable @typescript-eslint/explicit-function-return-type */
const legalRoutes: FundriseRouteConfig[] = [
	{
		path: `/legal/ira-fee-payment-program`,
		name: 'ira-paid-fees-terms-and-conditions',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		component: () => import('@views/ira/general/ira-paid-fees-terms-and-conditions.vue')
	},
	{
		path: `/legal/invitation-program`,
		name: 'referral-terms-conditions',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		component: () => import('@views/referral/referral-terms-conditions.vue')
	},
	{
		path: `/legal/disclosure`,
		name: 'disclosures',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		component: () => import('@views/legal/disclosures-view.vue')
	},
	{
		path: `/legal/new-user-reward`,
		name: 'legal-new-user-reward',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		component: () => import('@views/legal/new-user-reward.vue')
	},
	{
		path: `/legal/pro-membership`,
		name: 'pro-membership-agreement',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		component: () => import('@views/legal/pro-membership-agreement.vue')
	},
	{
		path: `/legal/reward-program`,
		name: 'starter-promo-terms',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		component: () => import('@views/legal/starter-promo.vue')
	},
	{
		path: `/legal/advisory-fee-waiver`,
		name: 'advisory-fee-waiver',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		component: () => import('@views/legal/advisory-fee-waiver.vue')
	},
	{
		path: `/legal/reward-share-voucher-program`,
		name: 'reward-share-voucher-program',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		component: () => import('@views/legal/reward-share-voucher-program.vue')
	},
	{
		path: `/oc`,
		name: 'offering-circulars',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		component: () => import('@views/legal/offering-circulars.vue')
	},
	{
		path: `/oc/links`,
		name: 'offering-circulars-links',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		component: () => import('@views/legal/offering-circulars.vue')
	},
	{
		path: `/webview/legal/new-user-reward`,
		name: 'webview-legal-new-user-reward',
		meta: { minTokenScopeRequired: 'UNAUTHENTICATED' },
		component: () => import('@views/webview/webview-new-user-reward.vue')
	}
];

export default legalRoutes;
